import * as React from "react";
import ShowNotice from "../../modules/ShowNotice";

export default (props) => <ShowNotice {...props} />;
